import { render, staticRenderFns } from "./DocumentosTransferCRUD.vue?vue&type=template&id=225cb54a"
import script from "./DocumentosTransferCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentosTransferCRUD.vue?vue&type=script&lang=js"
import style0 from "./DocumentosTransferCRUD.vue?vue&type=style&index=0&id=225cb54a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports